'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { string, bool } = propTypes;
const classNames = require( 'classnames' );
const createReactClass = require('create-react-class');

const SearchButton = createReactClass({
  propTypes: {
    searchText: string,
    pleaseWaitText: string,
    hideArrow: bool,
    column: bool
  },

  getDefaultProps( ) {
    return {
      searchText: 'Find parking',
      pleaseWaitText: 'Please wait ...',
      hideArrow: false,
      column: false
    }
  },

  getInitialState( ) {
    return { buttonText: this.props.searchText }
  },

  componentDidMount( ) {
    window.onpageshow = ( e ) => { if ( e.persisted ) window.location.reload( ) }
  },

  updateButtonText( ) {
    const { pleaseWaitText } = this.props;
    this.setState({ buttonText: pleaseWaitText });
    return true;
  },

  render( ) {
    const { buttonText } = this.state;
    const { hideArrow, column } = this.props;

    const containerClass = classNames({
      'submitContainer': true,
      'col-md-2': column
    })

    return (
      <li className={ containerClass }>
        <button
          className="btn hx-btn-ultimate btn-lg btn-block submit hxtrack"
          data-hxtrack-name="engine-search-button"
          data-track-location="page"
          data-track-name="search-button"
          type="submit"
          onClick={ this.updateButtonText }
        >
          { buttonText }
          { !hideArrow && (
            <i className="fa fa-arrow-right" />
          )}
        </button>
      </li>
    );
  }
});

module.exports = SearchButton;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/searchButton.jsx